export const GET_INVENTORY_HISTORY = 'GET_INVENTORY_HISTORY';
export const GET_INVENTORY_HISTORY_SUCCESS = `${GET_INVENTORY_HISTORY}/SUCCESS`;
export const GET_INVENTORY_HISTORY_FAILURE = `${GET_INVENTORY_HISTORY}/FAILURE`;

export const GET_INITIAL_DATA = 'GET_INITIAL_DATA';
export const GET_INITIAL_DATA_SUCCESS = `${GET_INITIAL_DATA}/SUCCESS`;
export const GET_INITIAL_DATA_FAILURE = `${GET_INITIAL_DATA}/FAILURE`;

export default {
  GET_INVENTORY_HISTORY,
  GET_INVENTORY_HISTORY_SUCCESS,
  GET_INVENTORY_HISTORY_FAILURE,
  GET_INITIAL_DATA,
  GET_INITIAL_DATA_SUCCESS,
  GET_INITIAL_DATA_FAILURE
};
